/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd and/or Orbit Tickets Ltd. All rights reserved.
This file contains a combination of:
- Protected Intellectual Property owned by Kaleida Ltd; and
- Custom / Included Intellectual Property owned by the Customer,
and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (being any application not developed by Kaleida), whether or not such application forms part of the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, where separation between Protected Intellectual Property and Custom / Included Intellectual Property is unclear, this file shall be treated as containing Protected Intellectual Property.
*/

// IP-NOTICE: MIXED
import {Component, AfterViewInit, ViewChild, inject, Injector, DestroyRef} from '@angular/core';
import {AsideContentDirective} from '../../directives/aside-content.directive';
import {DynamicComponent} from '../../../shared/base/aside/dynamic-component';
import {ComponentItem} from '../../../shared/base/aside/component-item';
import {DefaultAsideComponent} from './default-aside.component';
import {AsideService} from 'app/layout/components/aside-container/aside.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';

@Component({
  selector: 'aside-container',
  templateUrl: './aside-container.component.html',
  standalone: false,
})
export class AsideContainerComponent implements AfterViewInit {
  @ViewChild(AsideContentDirective, {static: false})
  asideContent!: AsideContentDirective;

  private readonly asideService = inject(AsideService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly injector = inject(Injector);

  ngAfterViewInit(): void {
    this.asideService.componentProvided.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((componentItem: ComponentItem) => {
      this.loadComponent(componentItem);
    });

    this.asideService.componentUnset.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.loadComponent(new ComponentItem(DefaultAsideComponent, {}));
    });
  }

  private loadComponent(componentItem: ComponentItem): void {
    const viewContainerRef = this.asideContent.viewContainerRef;
    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentItem.component, {
      injector: this.injector,
    });

    (componentRef.instance as DynamicComponent).data = componentItem.data;
  }
}
